// CaptchaButton.js
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { GoogleReCaptchaContext } from "react-google-recaptcha-v3";

// Create a regular function that takes executeRecaptcha as a parameter
export const grabCaptchaToken = async (executeRecaptcha) => {
  if (!executeRecaptcha) {
    return {
      type: "error",
      message: "Captcha not available. Please Refresh.",
      captchaToken: null,
    };
  }
  if (window.location.hostname === "127.0.0.1") {
    return {
      type: "localhost",
      message: "Captcha not available in localhost",
      captchaToken: null,
    };
  }

  try {
    const captchaToken = await executeRecaptcha("checkoutPayment");
    console.log("captchaToken", captchaToken);
    return {
      type: "info",
      message: "Captcha verified successfully!",
      captchaToken: captchaToken,
    };
  } catch (error) {
    return {
      type: "error",
      message: "Error during captcha verification. Please Refresh.",
      captchaToken: null,
    };
  }
};

// Keep the hook version for functional components
export const useGrabCaptchaToken = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  return grabCaptchaToken(executeRecaptcha);
};
